import React from 'react';

const IconMT = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4774_387927)">
      <circle cx="12" cy="12" r="12" fill="#2A3D45" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10ZM16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18ZM12 7C12 6.44772 12.4477 6 13 6H16C17.1046 6 18 6.89543 18 8V11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11V9.41419L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3165 5.90237 16.6834 6.29289 16.2929L14.5858 8H13C12.4477 8 12 7.55228 12 7Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4774_387927">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconMT;
